import React from 'react';
import '../styles/DevWarningBanner.css';

function DevWarningBanner() {
  return (
    <div className="dev-warning-banner">
      <div className="warning-icon">⚠️</div>
      <div className="warning-content">
        <strong>DEVELOPMENT & TESTING ENVIRONMENT</strong>
        <p>This interface is for development and testing purposes only. Do not use in production.</p>
      </div>
      <div className="warning-icon">⚠️</div>
    </div>
  );
}

export default DevWarningBanner;
